import { GsFormSchema } from '../../../components';
import { ACTIVE_SCHEMA_FIELDS } from './../basics/active.schema';
import { BASIC_SCHEMA_FIELDS } from './../basics/basic.schema';
import { HORIZONTAL_ALIGNMENT_SCHEMA } from './alignment.schema';
import { SPACING_SCHEMA } from './spacing.schema';

/** Maximum number of steps, matches `PageSteps.MaxSteps` in the backend */
export const PAGE_STEPS_MAX_STEPS = 5;

/**
 * Form schema for the PageSteps component settings in the designer. The backend resolves the
 * pages of the steps and marks the current one.
 */
export const PAGE_STEPS_COMPONENT_FORM_SCHEMA: GsFormSchema = {
  fields: [
    ...ACTIVE_SCHEMA_FIELDS,
    ...BASIC_SCHEMA_FIELDS,
    ...SPACING_SCHEMA,
    ...HORIZONTAL_ALIGNMENT_SCHEMA,
    {
      formControlName: 'linkFollowingSteps',
      label: 'components.pageSteps.schema.linkFollowingSteps',
      description: 'components.pageSteps.schema.linkFollowingStepsDescription',
      type: 'checkbox',
      default: false
    },
    {
      formControlName: 'steps',
      label: 'components.pageSteps.schema.steps',
      type: 'object-list',
      maxObjectsAmount: PAGE_STEPS_MAX_STEPS,
      addObjectLabel: 'components.pageSteps.schema.addStep',
      default: [],
      objectSchema: {
        fields: [
          {
            formControlName: 'page',
            label: 'components.pageSteps.schema.page',
            type: 'object-select-async',
            // No loadData: the designer supplies the page loader for this dialog name
            dialogName: 'SelectPageDialog',
            headerTitle: 'pages.title',
            placeholderTitle: 'components.pageSteps.schema.pagePlaceholder',
            default: undefined
          },
          {
            formControlName: 'displayName',
            label: 'components.pageSteps.schema.displayName',
            description: 'components.pageSteps.schema.displayNameDescription',
            type: 'text',
            default: ''
          },
          {
            formControlName: 'loggedInConstraint',
            label: 'components.pageSteps.schema.loggedInConstraint',
            type: 'select',
            valueType: 'string',
            default: '',
            options: [
              { text: 'components.pageSteps.schema.loggedInConstraintAlways', value: '' },
              { text: 'components.pageSteps.schema.loggedInConstraintLoggedIn', value: 'loggedIn' },
              { text: 'components.pageSteps.schema.loggedInConstraintLoggedOut', value: 'loggedOut' }
            ]
          },
          // Last on purpose: gs-object-list narrows the last input to make room for its delete button
          {
            formControlName: 'sortIndex',
            label: 'components.pageSteps.schema.sortIndex',
            type: 'number',
            min: 1,
            default: 1
          }
        ]
      }
    }
  ]
};
